import { useEffect, useMemo } from "react";

import Accordion from "@/components/atoms/accordion/accordion";
import { useRenewalStateContext } from "@/providers/renewal-state-provider";
import { RenewalSectionType } from "@/types/renewals";

type MiddlePanelLoadedSingleItemProps = {
  itemId: RenewalSectionType;
  title: string;
  content: React.ReactElement;
  isInitialLoad?: boolean;
  setIsInitialLoad?: (isInitialLoad: boolean) => void;
};
export default function MiddlePanelLoadedSingleItem({
  itemId,
  title,
  content,
  isInitialLoad,
  setIsInitialLoad,
}: Readonly<MiddlePanelLoadedSingleItemProps>) {
  const {
    expandedSections,
    setExpandedSections,
    isSelectItemByLeftPanel,
    setIsSelectItemByLeftPanel,
  } = useRenewalStateContext();

  const isInitioalLoad = useMemo(() => {
    return isInitialLoad;
  }, [isInitialLoad]);

  const handleClickExpand = () => {
    if (expandedSections.indexOf(itemId) !== -1) {
      const newActiveArr = expandedSections.filter((item) => item !== itemId);
      setExpandedSections(newActiveArr);
      sessionStorage.setItem("expandedSections", JSON.stringify(newActiveArr));
    } else {
      const newActiveArr = [...expandedSections, itemId];
      setExpandedSections(newActiveArr);
      sessionStorage.setItem("expandedSections", JSON.stringify(newActiveArr));
    }
    if (itemId === "medical-conditions") {
      sessionStorage.setItem("isMedicalAccordionOpen", "true");
    }
  };

  function scrollInputToSection() {
    const accordionSection = document.getElementById(`accordion-${itemId}`);
    if (accordionSection) {
      accordionSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  useEffect(() => {
    if (
      expandedSections.at(-1) === itemId &&
      isSelectItemByLeftPanel &&
      isInitioalLoad
    ) {
      if (setIsInitialLoad) setIsInitialLoad(false);
      setTimeout(() => {
        scrollInputToSection();
        setIsSelectItemByLeftPanel(false);
      }, 1500);
    } else if (expandedSections.at(-1) === itemId && isSelectItemByLeftPanel) {
      scrollInputToSection();
      setIsSelectItemByLeftPanel(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandedSections]);

  return (
    <div className="rounded-radius-xxl bg-surface-neutral-option-1 ">
      <Accordion
        title={
          <h2 className="font-header-font font-[400] text-text-title text-start lg:leading-[28px] md:leading-[34px] leading-[30px] lg:text-l md:text-3xl text-xl">
            {title}
          </h2>
        }
        content={content}
        id={itemId as unknown as string}
        isexpanded={expandedSections.indexOf(itemId) !== -1}
        onClick={() => handleClickExpand()}
      />
    </div>
  );
}
